import { render, staticRenderFns } from "./DataPointsPage.vue?vue&type=template&id=67199088&scoped=true&"
import script from "./DataPointsPage.vue?vue&type=script&lang=ts&"
export * from "./DataPointsPage.vue?vue&type=script&lang=ts&"
import style0 from "./DataPointsPage.vue?vue&type=style&index=0&id=67199088&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67199088",
  null
  
)

export default component.exports